module.exports = __webpack_public_path__ + "img/SST.e4537e2b.png";